import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { HttpService } from '../http.service';
import { SnackbarService } from '../snackbar.service';
import { DateTime } from "luxon";
import { MatDialog, MatPaginator ,PageEvent} from '@angular/material';
import { EventService } from '../event.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { StorageService } from '../storage.service';
import { JsplDetailsViewComponent } from '../jspl-details-view/jspl-details-view.component';
import { TimeService } from '../time.service';

@Component({
  selector: 'app-external-parking-vehicles',
  templateUrl: './external-parking-vehicles.component.html',
  styleUrls: ['./external-parking-vehicles.component.scss']
})
export class ExternalParkingVehiclesComponent implements OnInit {
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild("showData", { static: true }) showData: TemplateRef<any>;
  @ViewChild("addObdDialog", { static: true }) addObdDialog: TemplateRef<any>;
  @ViewChild("addRemarkDialog", { static: true }) addRemarkDialog: TemplateRef<any>;
  selectedRowIndex:any;
  pageEvent: PageEvent;
  showLoader = false;
  // fromDate:any='';
  // toDate:any='';
  displayedColumns: string[] = [
    "sno",
    "vehicle",
    "capacity",
    "carrier",
    "prefferedLocation",
    "material",
    "prefferedLoad",
    "age",
    "driver",
    "regNo",
    "PlantConfirmation",
    "remarks",
    "comments",
    // "action",
  ];
  rowDisplayedColumns = ['sno', 'gate_entry_no', 'vehicle_details', 'od_status', 'driver_details']
  externalParkingvehicles: any = [];
  externalParkingFilter: any= {
    limit: 0,
    skip: 0,
  };
  registeredFor: any = [];
  totalvehicles = 0;
  carrierUpdates: Subscription;
  reasons: any;
  shipperRemark: any;
  attachedDriver: any;
  dialogRef: any;
  showDialogRef: any;
  rowData:any;
  odNumber;
  vehicleNumber;
  states: any;
  country: any;
  carriers: any[];
  units: any[];
  selectedVehicle: any;
  obdNumber = "";
  carrierUnit = '';
  selectedCarrier: any;
  selectedUnit: any;
  registedredFor: any;
  carrierType = '';
  preferredZone = '';
  preferredLocation = '';
  selectedId: any;
  vehicleQty = '';
  materialName: any = [];
  customer_name = '';
  obdDialogRef: any;
  comment = '';
  remarkDialogRef: any;
  remarks = "";
  registeredForId: any = [];
  searchCarrier: any;
  carrier : string;
  vehicle_number: string;
  searchVehicleNo: any;
  currentUnit = true;
  advanceRegVeh: boolean = false;
  twentyfourhourscount = 0;
  fourtyeighthourscount = 0;

  constructor(private http: HttpService,private storage: StorageService, private snackBar: SnackbarService, private events: EventService, private dialog: MatDialog,private timeservice: TimeService) { }


  ngOnInit(): void {
    // this.getCarriers();
    const shipperData = JSON.parse(localStorage.getItem('carriers'));
    this.country = shipperData[0].country;

    // let myCurrentDate = new Date();
    // let myPastDate = new Date(myCurrentDate);   
    // myPastDate.setDate(myPastDate.getDate() - 10);
    this.getExternalParkingVehicles();
    // this.fromDate = '';
    // this.toDate = '';
   
    this.carrierUpdates = this.events.getCarrierIdChanges().subscribe(
      (data: any) => {
        this.getExternalParkingVehicles();
      }
    );
    
  }

  getExternalParkingVehicles(filter: any = {}) {
    this.externalParkingvehicles = [];
    this.showLoader = true;
    filter.limit = this.paginator.pageSize || 25;
    filter.skip = this.paginator.pageIndex * (this.paginator.pageSize || filter.limit);
    // filter.allUnit = false;
    filter.allUnit = true;
    if(this.currentUnit){
      filter.allUnit = false;
    }
    if (this.advanceRegVeh) filter.advanceRegVehicles = true;
    // if(this.fromDate){
    //   filter.from = DateTime.fromJSDate(this.fromDate).startOf("day").toUTC();
    // }
    // if(this.toDate){
    //   filter.to = DateTime.fromJSDate(this.toDate).endOf("day").toUTC();
    // }
    // if (this.searchCarrier) {
    //   filter.carrier = this.searchCarrier;
    // }
    if (this.searchVehicleNo) {
      filter.vehicle_no = this.searchVehicleNo;
    }
    
      this.http.get('externalParking/many', filter).subscribe((data: any) => {
        this.showLoader = false;
        if (data.statusCode === 200) {
          if(data.data.count == 0 && this.searchCarrier) {
            this.snackBar.openSnackBar('No Results Found', "", "err");
            this.showLoader = false;
            return
          }
          // this.externalParkingvehicles = data.data.records;
          data.data.records.forEach(element => {
            const temp:any = {};
            temp.regId = element.regId;
            temp.regTime = element.regTime;
            temp.vehicle = element.vehicle;
            temp.gps_provider = element.gps_provider;
            temp.name = element.name;
            temp.mobile = element.mobile;
            temp.loadQty = element.loadQty;
            temp.online = element.online;
            temp.is_temporary = element.is_temporary;
            temp.transp_name = element.transp_name;
            temp.transType = element.transType;
            temp.carrierUnit = element.carrierUnit;
            temp.cust_name = element.cust_name;
            temp.destination = element.destination;
            temp.obdNumbers = element.obdNumbers;
            temp.material = element.material;
            temp.remarks = element.remarks;
            temp.doStatus = element.doStatus.toString();
            temp.gpsLoc = element.gpsLoc;
            temp.aging = element.aging;
            temp.desiredWeight = element.desiredWeight;
            temp._id = element._id;
            temp.plantConfirmationTime = element.submissionPCTime != 'N/A' ? this.timeservice.toShortDateTime24(element.submissionPCTime) : element.submissionPCTime;
            temp.vehicleCallTime = element.vehicleCallTime != 'N/A' ? this.timeservice.toShortDateTime24(element.vehicleCallTime) : element.vehicleCallTime; 
            this.externalParkingvehicles.push(temp);
          });
          if (this.externalParkingvehicles.length && this.externalParkingvehicles.remarks && this.externalParkingvehicles.remarks.length) this.externalParkingvehicles.remarksJoined = this.externalParkingvehicles.remarks.shift().join(', ');
          console.log(this.externalParkingvehicles)
          this.totalvehicles = data.data.count;
          let res = data.data.records.filter(x => (x.aging != 'N/A'))
        this.twentyfourhourscount = res.filter(x => parseInt(x.aging) > 24).length;
        this.fourtyeighthourscount = res.filter(x => parseInt(x.aging) > 48).length;
        }
      }, (err: any) => {
        this.showLoader = false;
        this.snackBar.openSnackBar(err.error.message, '', 'err');
      })
  }

  // edit() {

  // }
  pageNavigate(event: PageEvent) {
    this.externalParkingFilter.limit = event.pageSize;
    this.externalParkingFilter.skip = event.pageIndex * event.pageSize;
    this.getExternalParkingVehicles(this.externalParkingFilter);
  }

  openUpdateRemarks(element) {
    this.shipperRemark = '';
    this.attachedDriver = element.driver;
    
    console.log('this.registeredFor>>>', this.registeredFor, this.registeredForId);
    this.dialogRef = this.dialog.open(this.addRemarkDialog);
    this.getShipperRemarks();
  }
  applyFilter(filterValue: string, type: string) {

    // if (type == "carrier") {
    //   this.searchCarrier = filterValue;
    //   if (filterValue.length == 0 || filterValue.length > 3) {
    //     this.getExternalParkingVehicles();
    //   }
    // }
    if (type == "vehicleno") {
      this.searchVehicleNo = filterValue;
      if (filterValue.length == 0 || filterValue.length > 3) {
        this.getExternalParkingVehicles();
      }
    }
  }
  // clearCarrier() {
  //   this.carrier = "";
  //   this.searchCarrier = "";
  //   this.applyFilter("", "carrier");
  // }
  clearVehicleNumber() {
    this.vehicle_number = "";
    this.applyFilter("", "vehicleno");
  }

  getShipperRemarks() {
    this.http.get('constants/get_reasons?name=jsplOBDremarks').subscribe(
      (data: any) => {
        if (data.statusCode === 200) {
          this.reasons = data.data[0].reason;
        }
      },
      (err: any) => {
        this.snackBar.openSnackBar(err.error.message, '', 'err');
      }
    );
  }
  updateRemarks() {
    this.http.post('inPlantVehicles/updateRemarks', { shipper_remark: this.shipperRemark, attached_driver: this.attachedDriver }, 2).subscribe(
      (data: any) => {
        if (data.statusCode === 200) {
          this.snackBar.openSnackBar('Updated successfully');
          this.getExternalParkingVehicles();
          this.dialogRef.close();
        }
      },
      (err: any) => {
        this.snackBar.openSnackBar(err.error.message, '', 'err');
      }
    )
  }

  download() {
    let request: any = {};
    // if (this.fromDate && this.toDate) {
    //   const from: any = DateTime.fromJSDate(this.fromDate)
    //     .startOf("day")
    //     .toUTC();
    //   const to: any = DateTime.fromJSDate(this.toDate).endOf("day").toUTC();

    //   request.from = from.ts;
    //   request.to = to.ts;
    // }
    let url = 'ex_parking_vehicles/all';
    if (this.currentUnit) url = 'ex_parking_vehicles'
    this.http.post("v1/reports/" + url, request, 2).subscribe(
      (response: any) => {

        this.showLoader = false;
        window.open(response.data.link, "_blank");
      },
      (err: any) => {
        this.showLoader = false;
        this.snackBar.openSnackBar(err.error.message, "", "err");
      }
    );
  }
  getOrderStatus (row,i){
    this.selectedRowIndex= i;
    this.rowData=[];
    this.vehicleNumber= row.vehicle;
    this.odNumber = row.od_status || 'N/A';
    const dialogRef = this.dialog.open(JsplDetailsViewComponent, {
      data: this.rowData,
      width: '1250px',
      maxWidth: '95vw !important'
    });
    this.rowData.push(row) ;
  }
  getShippers() {
    const unitsArray: any = JSON.parse(this.storage.getFromLocalStorage('shippers'));
   this.units = [];

   unitsArray.forEach((element: any) => {
     const temp: any = {};

     temp._id = element._id;
     temp.name = element.name;
     temp.parent_name = element.parent_name || 'NA';
     if (element.country && element.country.currency) {
       temp.currency = element.country.currency.symbol;
     }
     this.units.push(temp);
   });
 }
  getCarriers() {
   this.carriers = [];
   this.http.get('carriers').subscribe((response: any) => {
     if (response.data.length) {
       const carriers: any = response.data;
       carriers.forEach(element => {
         if (element.invite && (element.invite.status === 'verified')) {
           const temp: any = {};
           temp._id = element._id;
           temp.parent_name = element.parent_name ? element.parent_name : 'N/A';
           temp.name = element.name ? element.name : 'N/A';
           temp.carrierName = `${temp.parent_name}`;
           if (element.erp_reference && element.erp_reference.length) {
             const vendor = element.erp_reference[0];
             if (vendor.reference_id) {
               temp.vendor_code = vendor.reference_id;
             }
           }
           this.carriers.push(temp);
         }
       });
     }
   });

 }
 getLanesByCountry() {
   this.showLoader = true;
   this.http.get('lane?country=' + this.country._id).subscribe(
     (response: any) => {
       if (response.statusCode === 200) {
         this.showLoader = false;
         this.states = response.data;
         this.states.sort((a, b) => (a.a1.name > b.a1.name) ? 1 : -1);
         this.states = this.states.map(a => { return { _id: a.a1._id, name: a.a1.name } });
       }
     }
   );
 }
 openRemark(element) {
  this.remarks = "";
  this.obdNumber = "";
  this.selectedId = element._id;
  this.remarkDialogRef = this.dialog.open(this.addRemarkDialog);
}
  openAddObd(element) {
    console.log("element>>>", element);
    this.getLanesByCountry();
    this.getCarriers();
    this.getShippers();
    this.getShipperRemarks();
    this.selectedVehicle = element.vehicle;
    this.shipperRemark = element.remarks[0] || "";
    this.obdNumber = element.obdNumbers || "";
    this.carrierUnit = element.carrierUnit.parent_name + '-' + element.carrierUnit.name || '';
    this.selectedCarrier = element.carrierUnit._id || '';
    // if (element.registeredFor) this.selectedUnit = element.registeredFor || element.registeredFor._id || '';
    // if (element.registeredFor) this.registeredFor = element.registeredFor.parent_name ? element.registeredFor.parent_name + '-' + element.registeredFor.name : '';
    // // this.comment = element.comments || '';
    this.carrierType = element.transType || '';
    this.preferredZone = element.preferredZone || '';
    this.preferredLocation = element.destination ||  '';
    this.selectedId = element._id;
    this.materialName = element.material;
    this.customer_name = element.cust_name || '';  
    if (element.registeredFor && element.registeredFor.length) {
      this.registeredFor = element.registeredFor.map(ele => ele.name);
      this.registeredForId = element.registeredFor.map(ele => ele._id);
    }
    console.log("registered>>>", this.registeredFor, this.registeredForId);
    this.obdDialogRef = this.dialog.open(this.addObdDialog);
    
  }

  addObd() {
    const payload = {};
    if(this.obdNumber){
      payload['preferred_load'] = this.obdNumber;
    }
    if(this.shipperRemark){
      payload['shipper_remark'] = this.shipperRemark;
    }
    if (this.preferredZone) payload['preferred_zone'] = this.preferredZone;
    if (this.preferredLocation) payload['preferred_location'] = this.preferredLocation;
    if (this.carrierUnit) payload['carrier_unit'] = this.selectedCarrier;
    if (this.comment) payload['comments'] = this.comment;
    if (this.registeredFor) payload['registered_for'] = this.registeredForId;
    if (this.carrierType) payload['carrier_type'] = this.carrierType;
    if (this.vehicleQty) payload['capacity'] = this.vehicleQty;
    if (this.materialName) payload['material'] = this.materialName;
    if (this.customer_name) payload['customer_name'] = this.customer_name;
    this.http
      .put(
        "vehicle/add_obd/" + this.selectedId,
        payload,
        3
      )
      .subscribe(
        (data: any) => {
          if (data.statusCode === 200) {
            this.snackBar.openSnackBar(data.msg, "", "success");
            this.getExternalParkingVehicles();
            this.obdDialogRef.close();
            this.remarkDialogRef.close();
          }
        },
        (err: any) => {
          this.snackBar.openSnackBar(err.error.message, "", "err");
        }
      );
  }

  dummy(carrier_unit){
    let val =(carrier_unit.erp_reference && carrier_unit.erp_reference.length >0) ? carrier_unit.erp_reference[carrier_unit.erp_reference.length-1].reference_id: '';
    let selBox = document.createElement('textarea');
   selBox.style.position = 'fixed';
   selBox.style.left = '0';
   selBox.style.top = '0';
   selBox.style.opacity = '0';
   selBox.value = val;
   document.body.appendChild(selBox);
   selBox.focus();
   selBox.select();
   document.execCommand('copy');
   document.body.removeChild(selBox);
   this.snackBar.openSnackBar('Copied', "");
 }

 selectUnit(ship, event) {
  console.log('ship>>', ship);
  if (event.source._selected && this.registeredForId.indexOf(ship._id) == -1) {
    this.registeredForId.push(ship._id);
  } else if (this.registeredForId.indexOf(ship._id) != -1) {
    this.registeredForId.splice(this.registeredForId.indexOf(ship._id), 1);
  }
  console.log('registered>>>', this.registeredForId);
}
allUnitData(){
  this.currentUnit=!this.currentUnit;
  this.getExternalParkingVehicles();
}
advanceRegVehicles() {
  this.advanceRegVeh = !this.advanceRegVeh;
  this.getExternalParkingVehicles();
}

ngOnDestroy() {
  this.carrierUpdates.unsubscribe();
 }

}
